module.exports = __webpack_public_path__ + "media/images/countrysquared/gw-5d977ab2dbadaba19139762f80b76fed.svg";